<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">添加课程</span>

    <div class="bottom_div">
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-plus"
        @click="add_course_but"
      >
        添加课程
      </el-button>

      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="CreatedAt" label="日期"></el-table-column>
        <el-table-column prop="Name" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.UpdatedAt" style="width:100px;" />
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="课程名称"></el-table-column>
        <el-table-column label="科目">
          <template slot-scope="scope">
            <el-tag size="mini">
              {{ scope.row.CourseType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_principal_button(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加/修改课程弹框 -->
    <el-dialog
      :title="form.Id ? '修改课程' : '添加课程'"
      :visible.sync="add_course_subject"
      width="40%"
      :closeOnClickModal="false"
    >
      <el-form
        :inline="true"
        ref="formRef"
        :model="form"
        class="demo-form-inline"
        label-width="80px"
        label-position="left"
      >
        <el-form-item
          label="上传图片"
          prop="image"
          :rules="[
            {
              required: true,
              message: '图片不能为空',
              trigger: ['change', 'blur'],
            },
          ]"
          style="display: block;"
        >
          <el-upload
            ref="removeUpload"
            class="upload-demo"
            :action="uploadURL"
            :on-success="upload_success"
            :on-remove="upload_remove"
            :on-preview="upload_preview"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            style="width:100%;"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="科目"
          prop="type"
          :rules="[{ required: true, message: '科目不能为空' }]"
          style="display:block;"
        >
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width:178px;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="标题"
          prop="name"
          :rules="[{ required: true, message: '标题不能为空' }]"
        >
          <el-input v-model="form.name" placeholder="请输入课程标题"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_course_subject = false" size="mini"
          >取消</el-button
        >
        <el-button type="primary" @click="add_principal_frame" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import loading from "@/components/loading.vue";
import { mapGetters } from "vuex";
import {
  upload_resources_image_api,
  post_image_url_api,
} from "@/api/resources.js";
import {
  add_course_api,
  getCourse,
  putSubject,
  delete_subject,
} from "@/api/addAccount.js";

export default {
  computed: {
    ...mapGetters(["current"]),
  },
  components: {
    loading,
  },

  data() {
    return {
      add_course_subject: false, //添加课程科目弹框打开关闭
      tableData: [], //表格数据
      form: { image: "", type: "", name: "" }, //表单数据
      uploadURL: "",
      options: [
        {
          value: "C++",
          label: "C++",
        },
        {
          value: "Python",
          label: "Python",
        },
        {
          value: "Scratch",
          label: "Scratch",
        },
        {
          value: "机器人",
          label: "机器人",
        },
      ],
      loading_ok: "",
    };
  },

  created() {
    this.getCourse_but();
    this.uploadURL = upload_resources_image_api();
    console.log(this.uploadURL);
  },

  methods: {
    //获取课程
    getCourse_but() {
      getCourse(this.current).then((response) => {
        response.data.forEach((v) => {
          v.CreatedAt = this.filters.vdateAdd(v.CreatedAt);

          post_image_url_api([v.Image]).then((res) => {
            v.UpdatedAt = "http://" + res.data[0];
          });
        });
        this.loading_ok = false;
        this.tableData = response.data;
      });
    },

    //添加课程按钮
    add_course_but() {
      if (this.$refs.formRef !== undefined) {
        this.$refs.formRef.resetFields();
      }
      delete this.form.Id;
      this.form.name = "";
      this.form.type = "";
      this.add_course_subject = true;
    },

    // 表格修改按钮
    editCampus(item) {
      this.add_course_subject = true;
      this.form.name = item.Name;
      this.form.type = item.CourseType;
      this.form.image = item.Image;
      this.form.Id = item.Id;
    },

    // 表格删除按钮
    delete_principal_button(item) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_subject(item.Id).then(() => {
            this.getCourse_but();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 弹框确定按钮
    add_principal_frame() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.form.Id) {
            putSubject(this.form.Id, {
              name: this.form.name,
              type: this.form.type,
              image: this.form.image,
            }).then(() => {
              this.getCourse_but();
              this.$message.success("修改成功！");
              this.add_course_subject = false;
            });
          } else {
            add_course_api({
              image: this.form.image,
              type: this.form.type,
              name: this.form.name,
            }).then(() => {
              this.getCourse_but();
              this.$message.success("添加成功！");
              this.add_course_subject = false;
            });
          }
        }
      });
    },

    // 上传成功钩子
    upload_success(res) {
      console.log(res);
      this.form.image = res.Id;
    },

    // 点击上传文件钩子
    upload_preview(res) {
      console.log(res.response.Url);
    },

    // 移除上传文件钩子
    upload_remove() {
      this.form.image = "";
    },

    // 超出上传文件个数钩子
    handleExceed() {
      this.$message.error("目前仅支持上传单个文件");
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .bottom_div {
      margin-top:30px;
    }
    .table {
      margin-top:16px;
    }
}
</style>
